/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Pricing_DescriptionInputs */

const en_seo_pricing_description = /** @type {(inputs: Seo_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Complete Athlete free with 3 workouts and 3 meal scans, then 49 zł a month or 249 zł a year. Booking specialists and anything they give you stays free.`)
};

const pl_seo_pricing_description = /** @type {(inputs: Seo_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij Complete Athlete za darmo: 3 treningi i 3 skany posiłków, potem 49 zł miesięcznie albo 249 zł rocznie. Rezerwacje u specjalistów i wszystko, co od nich dostajesz, zostają za darmo.`)
};

/**
* | output |
* | --- |
* | "Start Complete Athlete free with 3 workouts and 3 meal scans, then 49 zł a month or 249 zł a year. Booking specialists and anything they give you stays free." |
*
* @param {Seo_Pricing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_pricing_description = /** @type {((inputs?: Seo_Pricing_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Pricing_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_pricing_description(inputs)
	return en_seo_pricing_description(inputs)
});